<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <v-layout class="white ma-0 pa-0 no-gutters">
    <v-row>
      <v-col sm="6" class="align-left text-left mb-0 pb-0 ">
        <span
          v-if="
            $store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .report_type_to_generate === '1P1C'
          "
          class="small mr-8 pr-12 pa-0 ma-0"
        >
          <span class="home_dot"></span
          >{{
            `Home Market - ${$store.state.app.selectedHomeCountry} [${
              $store.state.app.selectedModelName
            }]`
          }}

          <span>
            <span class="green_dot_1p1c"></span
            >{{
              `Target Market - ${codeToMarket(
                $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
                  .C_Code[0],
              )}`
            }}
          </span>

          <span class="red_dot"></span>Major competing sources of imports into target
          market. Size indicates relative value imported from each competitor country.
        </span>
        <span
          v-if="
            $store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .report_type_to_generate === '1PMC' ||
              $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                .report_type_to_generate === 'MPMC' ||
              $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                .report_type_to_generate === 'MP1C'
          "
          class="small mr-8 pr-12"
        >
          <div class="ma-0 pa-0">
            <span class="home_dot"></span
            >{{
              `Home Market - ${$store.state.app.selectedHomeCountry} [${
                $store.state.app.selectedModelName
              }]`
            }}
          </div>
          <div>
            <span class="green_dot_1pmc"></span>Markets importing selected product(s) from
            all markets. Size indicates 'untapped' potential from home market's
            perspective.
          </div>
          <div><span class="grey_dot_1pmc"></span>No results.</div>
        </span>
      </v-col>
      <v-col sm="3" v-if="show_map_ta_overlay" class="mb-0 pb-0">
        <v-img
          contain
          content-class="img-center"
          max-height="100"
          max-width="65"
          :src="loader_institution_image_url()"
        ></v-img>
      </v-col>
      <v-col sm="3"> <span class="small_font">Map not to scale</span> </v-col>
    </v-row>
  </v-layout>
</template>
<script>
export default {
  name: 'trade-map-image',
  props: {
    show_map_ta_overlay: {},
  },
};
</script>

<style scoped>
p {
  background-color: cyan;
}

circle {
  stroke-width: 30px !important;
}

.small {
  font-size: 10px !important;
}
.overlay-small {
  position: absolute;
  /*color: rgb(0, 102, 153);*/
  left: 50%;
  bottom: 20px;
}

.overlay-large {
  position: absolute;
  /*color: rgb(0, 102, 153);*/
  left: 50%;
  bottom: 5px;
}

.small_font {
  font-size: 11px;
}
</style>
